import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../../AgGrid';
import { ReturnPreviewService } from '../returnPreview.service';
import { lastValueFrom } from 'rxjs';

export interface FormOverridesListDataSourceParams {
    returnIds: number[];
}

export class FormOverridesListAgGridDataSource extends AgGridDataSourceBase<FormOverridesListDataSourceParams> {
    constructor(
        private _gridApi: GridApi,
        private _returnPreviewService: ReturnPreviewService,
        protected _dataSourceParamsFn: () => FormOverridesListDataSourceParams
    ) {
        super(_gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Compliance.ReturnFormOverridePropertyEnum>[] = [
        { name: 'fieldName', value: Compliance.ReturnFormOverridePropertyEnum.FieldName },
        { name: 'fieldNameDisplay', value: Compliance.ReturnFormOverridePropertyEnum.FieldNameDisplay },
        { name: 'formRevisionId', value: Compliance.ReturnFormOverridePropertyEnum.FormRevisionId },
        { name: 'value', value: Compliance.ReturnFormOverridePropertyEnum.Value },
        { name: 'formRevisionName', value: Compliance.ReturnFormOverridePropertyEnum.FormRevisionName },
        { name: 'parcelAcctNumberDisplay', value: Compliance.ReturnFormOverridePropertyEnum.ParcelAcctNumberDisplay },
        { name: 'parcelAssessorName', value: Compliance.ReturnFormOverridePropertyEnum.AssessorName }
    ];

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Compliance.ReturnFormOverrideSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap),
            returnIds: this._dataSourceParams.returnIds
        };

        const result = await lastValueFrom<Compliance.QueryResultModel<Compliance.ReturnFormOverrideDetailModel>>(this._returnPreviewService.getFormFieldOverrides(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows
        } as AgGridDataSourceResult;
    }
}
